import { registerReconnectHandler } from 'lib/search/socketEmitter'
import {
  disconnectSearchSocket,
  getSearchSocket as getSearchSocketBase,
  globalSearchSocket,
  SEARCH_STREAMING_PAGE_SIZE,
} from './getSearchSocket'

export { disconnectSearchSocket, globalSearchSocket, SEARCH_STREAMING_PAGE_SIZE }

/**
 * Returns the global search socket and ensures reconnect handlers are registered.
 */
export function getSearchSocket() {
  const socket = getSearchSocketBase()
  registerReconnectHandler(socket)
  return socket
}
